export const formatNumber = (val) => {
  if (!val) return 0;
  return Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 })
    .format(val)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const parserNumber = (val) => {
  if (!val) return 0;
  return parseFloat(
    `${val}`.replace(/,/, "#").replace(/\./g, "").replace(/#/, ".")
  );
};

export const formatNumberPostotak = (val) => {
  if (!val) return 0;
  return Intl.NumberFormat({ maximumFractionDigits: 2 }).format(val);
};
